<template>
  <v-dialog v-model="AddEditdialog" persistent max-width="500px" scrollable>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t(formTitle) }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form v-model="valid" ref="form" class="mt-5">
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <div class="form-group">
                  <label>{{ $t("Name") }}</label>
                  <v-text-field
                    v-model="editedItem.en.name"
                    :rules="[
                      validationRules.required,
                      validationRules.maxLength50
                    ]"
                    solo
                  ></v-text-field>
                  <div v-if="validation_errors.en.name">
                    <p
                      class="red--text"
                      v-for="(error, index) in validation_errors.en.name"
                      :key="index"
                    >
                      {{ error }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <div class="form-group">
                  <label>{{ $t("Arabic Name") }}</label>
                  <v-text-field
                    v-model="editedItem.ar.name"
                    solo
                    :rules="[
                      CheckArabicCharactersOnly(editedItem.ar.name),
                      validationRules.maxLength50
                    ]"
                  ></v-text-field>
                  <div v-if="validation_errors.ar.name">
                    <p
                      class="red--text"
                      v-for="(error, index) in validation_errors.ar.name"
                      :key="index"
                    >
                      {{ error }}
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <div class="form-group">
                  <label>{{ $t("Subject Types") }}</label>
                  <v-select
                    :items="subject_types"
                    item-text="name"
                    item-value="id"
                    v-model.trim="editedItem.subject_type_id"
                    :rules="[validationRules.required]"
                    @focus="onFocus()"
                    solo
                  >
                  </v-select>
                  <!-- <select
                class="custom-select"
                name="item_category_id"
                v-model.trim="editedItem.subject_type_id"
                @focus="onFocus()"
              >
                <option value="">Please Select Subject Type </option>
                <option
                  v-for="(subject_type, index) in subject_types"
                  :key="index"
                  :value="subject_type.id"
                  :selected="subject_type.id == editedItem.subject_type_id"
                  >{{ subject_type.name }}</option
                >
              </select> -->
                  <div v-if="validation_errors.subject_type_id">
                    <p
                      class="red--text"
                      v-for="(error,
                      index) in validation_errors.subject_type_id"
                      :key="index"
                    >
                      {{ error }}
                    </p>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn class="modal-btn-cancel" @click="close">{{ $t("Close") }}</v-btn>
        <v-btn
          class="modal-btn-save"
          @click="save"
          :loading="loading"
          :disabled="loading"
          >{{ $t("Save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { validationMixin } from "../../mixins/validationMixin";
export default {
  props: [
    "editedItem",
    "AddEditdialog",
    "formTitle",
    "editedIndex",
    "endPoints"
  ],
  name: "addEditSubjectComponent",
  mixins: [validationMixin],
  data() {
    return {
      valid: false,
      validation_errors: {
        en: {
          name: ""
        },
        ar: {
          name: ""
        },
        subject_type_id: ""
      },
      subject_types: [],
      loading: false
    };
  },
  watch: {
    AddEditdialog: {
      handler() {
        if (this.$refs.form) {
          this.resetValidation();
        }
      }
    }
  },
  methods: {
    close() {
      this.AddEditdialog = false;
      this.editedItem = {};
      this.validation_errors = {
        en: {
          name: ""
        },
        ar: {
          name: ""
        },
        subject_type_id: ""
      };
      this.$emit("childToParent", false, null, this.editedIndex);
    },
    onFocus() {
      this.validation_errors = {
        en: {
          name: ""
        },
        ar: {
          name: ""
        },
        subject_type_id: ""
      };
    },
    save() {
      if (!this.valid) {
        this.$refs.form.validate();
      } else {
        this.loading = true;
        if (this.editedIndex > -1) {
          axios
            .post(
              this.getApiUrl +
                "/" +
                this.endPoints.edit +
                "/" +
                this.editedItem.id,
              this.editedItem,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token
                }
              }
            )
            .then(response => {
              this.loading = false;
              if (response.data.status.error == true) {
                Object.assign(
                  this.validation_errors,
                  response.data.status.validation_errors
                );
              } else {
                this.AddEditdialog = false;
                this.$emit(
                  "childToParent",
                  false,
                  response.data.data,
                  this.editedIndex
                );
              }
            });
        } else {
          axios
            .post(
              this.getApiUrl + "/" + this.endPoints.create,
              this.editedItem,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token
                }
              }
            )
            .then(response => {
              if (response.data.status.error == true) {
                Object.assign(
                  this.validation_errors,
                  response.data.status.validation_errors
                );
              } else {
                this.disabledSubmitbtn = true;
                this.editedItem = {
                  en: {
                    name: ""
                  },
                  ar: {
                    name: ""
                  },
                  subject_type_id: ""
                };
                this.$emit(
                  "childToParent",
                  false,
                  response.data.data,
                  this.editedIndex
                );
                this.close();
              }

              this.loading = false;
            });
        }
      }
    }
  },
  mounted() {
    axios
      .get(this.getApiUrl + "/subject_types?select=yes", {
        headers: {
          Authorization: "Bearer " + localStorage.token
        }
      })
      .then(response => {
        this.subject_types = response.data.data;
        // console.log(this.subject_types);
      });
  }
};
</script>
<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";
.space {
  margin-top: -20px !important;
}
</style>
